import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import GUIUtilities from "@/utils/common/GUIUtilities.ts";
import {computed, ref, Ref} from "vue";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import DropDownFieldWidgetUtil, {ChoiceTranslator, DisplayedAllowedValue} from "@/utils/editView/widgets/DropDownFieldWidgetUtil.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import FieldMetaData = namaTypes.FieldMetaData;
import EntityReferenceData = namaTypes.EntityReferenceData;

export default class GenericReferenceFieldWidgetUtil extends FieldWidgetUtil
{
  private readonly _allowedValues: DisplayedAllowedValue[];
  private readonly translator: ChoiceTranslator;
  private readonly typeMetadata: FieldMetaData;
  shouldShowEntitySelector: boolean = true;
  entityTypeFieldId: string;
  defaultEntityType: Ref<string | null | undefined> = ref()

  constructor(presenter: WidgetsPresenter, fieldMetaData: FieldMetaData) {
    super(presenter, fieldMetaData);
    this.entityTypeFieldId = this.fieldId() ? this.fieldId() + "." + CommonFieldIds.ENTITY_TYPE : "";
    this.typeMetadata = GUIUtilities.createGenericRefEntityTypeMeta(this.entityTypeFieldId, fieldMetaData);
    this.translator = DropDownFieldWidgetUtil.createTranslator(this.typeMetadata);
    this._allowedValues = DropDownFieldWidgetUtil.createSortedAllowedValues(GUIUtilities.getAllowedValues(presenter.entityType, this.typeMetadata),
      this.typeMetadata.enumTypeName!, this.translator);
    if (this.allowedValues && this.allowedValues.length === 1) {
      this.shouldShowEntitySelector = false;
      this.defaultEntityType.value = this.allowedValues[0].id;
    } else if (this.typeMetadata.defaultEntityType) {
      this.defaultEntityType.value = this.typeMetadata.defaultEntityType;
    }
  }

  fetchEntityTypeFieldValue() {
    return NamaCommon.getFieldValue(this.presenter.fetchRecord(), this.fieldMetaData.fieldId! + "." + CommonFieldIds.ENTITY_TYPE);
  }

  get allowedValues(): DisplayedAllowedValue[] {
    return this._allowedValues;
  }

  formattedEntityTypeValue() {
    return computed(() => {
      let value = NamaCommon.getFieldValue(this.presenter.fetchRecord(), this.entityTypeFieldId);
      if (!this.allowedValues)
        return GenericReferenceFieldWidgetUtil.createAllowedValue(value || this.defaultEntityType.value);
      if (value)
        return this.allowedValues.find(l => l.id === value) || GenericReferenceFieldWidgetUtil.createAllowedValue(value);
      if (this.defaultEntityType.value)
        return this.allowedValues.find(l => l.id === this.defaultEntityType.value) ||
          GenericReferenceFieldWidgetUtil.createAllowedValue(value || this.defaultEntityType.value);
      return undefined;
    });
  }

  static createAllowedValue(value: string) {
    if (!value)
      return;
    return {id: value, title: value, searchValue: value}
  }

  override onUserInputFinished = async () => {
  }

  updateEntityType(newEntityType: string | null | undefined) {
    if (newEntityType === this.fetchEntityTypeFieldValue())
      return;
    let value: EntityReferenceData;
    if (!newEntityType)
      value = {};
    else
      value = {
        entityType: newEntityType
      };
    NamaCommon.setFieldValue(this.presenter.fetchRecord(), this.fieldId(), value);
  }

  onSelect = (value?: DisplayedAllowedValue) => {
    if (value)
      this.updateEntityType(value.id);
    else
      this.updateEntityType(undefined);
  }
}
